import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DoNotShowSidebarRouteOnRefreshGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.isPageRefresh()) {
      console.warn("Sidebar not allowed on refresh.");
      this.router.navigateByUrl("/");
      return false;
    }
    return true;
  }

  // I determine if the current route-request is part of a page refresh.
  private isPageRefresh(): boolean {
    return !this.router.navigated;
  }

}
